import { useUserStore } from "@/store/useUserStore"
import { useNavigate } from "@/hooks/useNavigate"

const showErrorToast = (message = "请求错误") => {
  uni.showToast({
    icon: "none",
    title: message,
  })
}

/**
 * 统一请求入口
 *
 * baseUrl 拼接、token 注入、query 序列化均由 src/interceptors/request.js 完成,
 * 此处只关心状态码判定与错误提示。
 *
 * options.hideErrorToast 为 true 时不弹出 toast,由调用方自行处理错误。
 */
export const http = (options) =>
  new Promise((resolve, reject) => {
    uni.request({
      ...options,
      dataType: "json",
      // #ifndef MP-WEIXIN
      responseType: "json",
      // #endif
      success(res) {
        const { statusCode, data } = res

        // 401 优先于状态码判定,业务码或 HTTP 401 都视为登录态失效
        if (statusCode === 401 || data?.code === 401) {
          useUserStore().clearUserInfo()
          useNavigate("/pages/login/index")
          reject(res)
          return
        }

        if (statusCode >= 200 && statusCode < 300) {
          resolve(data)
          return
        }

        if (!options.hideErrorToast) {
          showErrorToast(data?.msg || "请求错误")
        }
        reject(res)
      },
      fail(err) {
        if (!options.hideErrorToast) {
          showErrorToast("网络错误,换个网络试试")
        }
        reject(err)
      },
    })
  })

/**
 * 兼容入口,与 http 等价
 *
 * 保留 request 名称是为了兼容 scripts/generate-api.js 生成的接口产物,
 * 仅在调用前归一化 method 大小写。
 */
export const request = (options) => {
  const method = (options.method || "GET").toUpperCase()
  return http({ ...options, method })
}
